export const getCommandCenterPageConfigUrl = companyId =>
  `/api/companies/${companyId}/command-center-config`;

export const getSubCompanyCommandCenterPageConfigUrl = (companyId, subCompanyId) =>
  `/api/companies/${companyId}/sub-companies/${subCompanyId}/command-center-config`;

// DEV-4136: the "All subcompanies (default)" scope — every subcompany inherits
// this config unless it has its own per-subcompany override.
// Backend endpoint ships separately (ConfigScope=AllSubCompanies).
export const getAllSubCompaniesCommandCenterPageConfigUrl = companyId =>
  `/api/companies/${companyId}/sub-companies-default/command-center-config`;
